// Unico interruttore per i rami dell'app nativa (shell Capacitor). Legge solo
// `window.Capacitor`, iniettato dalla shell: nessun import di `@capacitor/core`,
// così il modulo resta importabile nel bundle web e nei test.
export function isNativo() {
  return globalThis.window?.Capacitor?.isNativePlatform?.() === true;
}

export function piattaformaNativa() {
  if (!isNativo()) return "web";
  return globalThis.window.Capacitor.getPlatform?.() ?? "web";
}
